import {makeAutoObservable} from "mobx";
import {RequestBody} from "../../entity/core/request-body";
import SearchAgent from "../agent/search-agent";
import {SearchResponse} from "../../entity/resource/search-response";

export default class SearchStore {
  searchAgent: SearchAgent;

  constructor(searchAgent: SearchAgent) {
    makeAutoObservable(this);
    this.searchAgent = searchAgent;
  }

  searchEntity = async (organizationId: string, requestBody: RequestBody): Promise<SearchResponse | string> => {
    try {
      const response = await this.searchAgent.searchEntity(organizationId, requestBody);
      return !Array.isArray(response) ? response : 'No data found !!';
    } catch (error: any) {
      console.error("Error occurred while perform search", error);
      return 'No data found !!'
    }
  }

}
